import { Typography, styled, Stack, Box, Divider } from "@mui/material";
import React, { useState } from "react";
import ConnectUserFunctional from '../Contacts/ConnectUsersFunctional'
import NewContactFunctional from "../../ContactsView/AddNewContact/NewContactFunctional";
import EmailInviteFunctional from "../Contacts/EmailInviteFunctional";
import { ADD_NEW_CONTACT_EMAIL_ICON_ACTIVE, ADD_NEW_CONTACT_EMAIL_ICON_INACTIVE, ADD_NEW_CONTACT_NEW_ICON_ACTIVE, ADD_NEW_CONTACT_NEW_ICON_INACTIVE, ADD_NEW_CONTACT_SEARCH_ACTIVE, ADD_NEW_CONTACT_SEARCH_INACTIVE } from "../../../utils/constants";
import SelectNavBox from "../../../components/common/SelectNavBox";
import AddContactIcon from "../../../components/ui/Modals/AddContactIcon";

const TABS = [
    {
        title: 'Connect with users',
        id: 'connectUsers',
        iconActive: ADD_NEW_CONTACT_SEARCH_ACTIVE,
        iconInactive:ADD_NEW_CONTACT_SEARCH_INACTIVE
    },
    {
        title: 'Create new contact',
        id: 'newContact',
        iconActive: ADD_NEW_CONTACT_NEW_ICON_ACTIVE,
        iconInactive:ADD_NEW_CONTACT_NEW_ICON_INACTIVE
    },
    {
        title: 'Send an email invitation to a friend',
        id: 'emailInvite',
        iconActive: ADD_NEW_CONTACT_EMAIL_ICON_ACTIVE,
        iconInactive:ADD_NEW_CONTACT_EMAIL_ICON_INACTIVE
    },
]


const AddNewContactFunctional = ({ cancel,selectedTabFromParent = null, fetchContacts,selectedDomain,selectedContactAction, ...props }) => {
    const [selectedTab, setSelectedTab] = useState(selectedTabFromParent || 'connectUsers');
    
    const handleSelectTab = (key) => {
        setSelectedTab(key);
    }

    const userDomain = selectedDomain.userDomain || '';

    const LabelWithIcon = ({label, icon}) => {
        return (
            <div className="add-contact-label-with-icon flex items-center">
                <div className="add-contact-navBox-icon me-2">
                    {
                        icon.svgIcon ?  (icon.svgIcon) :  <img src={icon} alt='label' width={"20px"} />
                    }
                </div>

                <Typography className={`${userDomain}_font`} sx={{ fontSize: '14px', fontWeight: '600' }}>{label}</Typography>
            </div>
        )
    }

    return <Stack spacing={4} sx={{ padding: '0 1.5rem 1rem' }}>
        <Stack flexDirection='row'>
          
            <div className="add-contact-content w-full pr-5 flex flex-col gap-2">
            {
                TABS.map(item => {
                    return(
                        <SelectNavBox
                            className=""
                            key={item.id}
                            leftNavComponent={<LabelWithIcon label={item.title} icon={selectedTab === item.id ? item.iconActive : item.iconInactive} />}
                            isActive={selectedTab === item.id}
                            customOnClickFn={() => handleSelectTab(item.id)}
                        />
                    )
                })
            }
            </div>
            <Divider orientation="vertical" flexItem style={{height:'480px'}}/>
            <Box sx={{ paddingLeft: '2rem', width: '100%' }}>
                {selectedTab === 'connectUsers' && <ConnectUserFunctional allProfileImages={props.allProfileImages} />}
                {selectedTab === 'newContact' && <NewContactFunctional edit={false} handleCancel={cancel} selectedDomain={selectedDomain} selectedContactAction={selectedContactAction} fetchContacts={fetchContacts}/>}
                {selectedTab === 'emailInvite' && <EmailInviteFunctional />}
            </Box>
        </Stack>
    </Stack>
};

export default AddNewContactFunctional;